import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'components/base/base.component';
import { lastValueFrom } from 'rxjs';
import { JornadaPsicologo, JornadaPsicologoAtividade } from 'src/app/shared/models/psicologo/JornadaPsicologo';
import { PsicologoUtilsService } from 'src/app/shared/services/psicologo-utils.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

interface AjustePontoRequest {
  codigoJornada: number;
  status:        number;
}

@Component({
    templateUrl: './aprovacao-ajuste-ponto.component.html',
    styleUrls: ['./aprovacao-ajuste-ponto.component.scss'],
    standalone: true,
    imports:[angularCommonImports,convivaCommonImports,libsCommonImports]
})


export class AprovacaoAjustePontoComponent extends BaseComponent implements OnInit {

   parametroId = 0;
   public atividadeId: number;
   public jornadaId: number;
   public atividade: JornadaPsicologoAtividade [] = [];
   public jornada?: JornadaPsicologo;
   totalHorasTrabalhadas?: Date;
   totalHorasAtividades?: Date;
   totalHorasTempoRegistro?: Date;
   showApproveConfirm = false;
   showRepproveConfirm = false;
   statusAprovacao = 0; // 0 - Pendente, 1 - Aprovado, 2 - Reprovado

setJornadaId() {
  this.route.queryParams.subscribe(params => {
    const id = params['id'];
    this.parametroId = id ? Number(id) : 0;
    this.jornadaId = id ? Number(id) : 0;
  });
}

  async ngOnInit() {
    this.setJornadaId();
    this.spinnerService.show();
    await this.getJornadaPorId();
    await this.getAtividadePorId();
     this.calculaTotalHorasTrabalhadas();
     this.spinnerService.hide();
  }

  closeModalApproveConfirm(): void {
    this.showApproveConfirm = false;
  }
  closeModalRepproveConfirm(): void {
    this.showRepproveConfirm = false;
  }

//INJECTIONS
   route = inject(ActivatedRoute);
   activatedRoute = inject(ActivatedRoute);
   psicologoUtilsService = inject(PsicologoUtilsService);
   location = inject(Location);

async getAtividadePorId() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getAtividadePorIdJornada(this.parametroId));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.atividade = response.data;
    this.toastr.success('Atividade encontrada com sucesso!');
    this.spinnerService.hide();
}

async getJornadaPorId() {
  this.spinnerService.show();
  const response = await lastValueFrom(this.psicologoService.getJornadaPorId(this.parametroId));
  if (!response.isSucess) {
    this.toastr.error(response.message, response.title);
    this.spinnerService.hide();
    return;
}
  this.jornada = response.data;
  this.calcularHoras();
  this.toastr.success("Jornada encontrada com sucesso!");
  this.spinnerService.hide();

}


setQueryParams() {
  this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.atividadeId = params.atividadeId;
        this.jornadaId = params.jornadaId;
      });
  }

get isAjusteEntrada(): boolean {
  return this.jornada?.hrAjusteEntrada != null;
}
get isAjusteSaida(): boolean {
  return this.jornada?.hrAjusteSaida   != null;
}



get dataInicio(): Date {
  return this.jornada?.hrAjusteEntrada ?? this.jornada?.dataInicio!;
}
get dataFim(): Date {
  return this.jornada?.hrAjusteSaida ?? this.jornada?.dataFim!;
}

  calcularHoras() {
    this.calculaTotalHorasTrabalhadas();
  }

calculaTotalHorasTrabalhadas(): void {
  if (!this.dataInicio || !this.dataFim) return;

  const diffMs =
    new Date(this.dataFim).getTime()
  - new Date(this.dataInicio).getTime();

  const diffMin = Math.floor(diffMs / 60000);
  const horas   = Math.floor(diffMin / 60);
  const minutos = diffMin % 60;

  // Aqui: usamos o construtor local, não UTC
  this.totalHorasTrabalhadas = new Date(
    1970,  // ano
    0,     // mês (janeiro = 0)
    1,     // dia
    horas,
    minutos,
    0
  );
}

  public gridAtividades = [
  {
    title: 'Data',
    field: 'dataAtividade',
    width: 150,
    hozAlign: 'center',
    headerHozAlign: 'center',
    formatter: (cell: any) => {
      const raw = cell.getValue();
      if (!raw) return '';
      const dt = new Date(raw);
      const d  = String(dt.getDate()).padStart(2, '0');
      const m  = String(dt.getMonth() + 1).padStart(2, '0');
      const y  = dt.getFullYear();
      return `${d}/${m}/${y}`;
    }
  },
    { title: 'Titulo da Atividade ', field: 'titulo', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
      {
    title: 'Tipo de Atividade',
    field: 'tipoAtividade',
    width: 150,
    hozAlign: 'center',
    headerHozAlign: 'center',
    formatter: (cell: any) => {
          const val = cell.getValue();
          switch (val) {
            case 1: return 'Acolhimento não Agendado';
            case 2: return 'Acolhimento Agendado';
            case 3: return 'Prevenção não Agendada';
            case 4: return 'Prevenção Agendado';
            default: return '';
  }
}
  },
      {
    title: 'Diretoria',
    field: 'nomeDiretoria',
    hozAlign: 'center',
    headerHozAlign: 'center',
    formatter: () => {
      return this.jornada?.nomeDiretoria ?? '';
    }
  },
      {
    title: 'Escola',
    field: 'nomeEscola',
    hozAlign: 'center',
    headerHozAlign: 'center',
    formatter: () => this.jornada?.nomeEscola ?? ''
  },
     {
    title: 'Tempo atividade',
    field: 'tempoAtividade',
    width: 200,
    hozAlign: "center",
    headerHozAlign: "center",
    formatter: (cell : any) => {
      const val = cell.getValue();
      return val != null ? `${val} MN` : '';
    }
  },

  ];

public async onReprovar() {
    this.spinnerService.show();
    const body: AjustePontoRequest = {
      codigoJornada: this.jornadaId,
      status:2
    };
    const response = await lastValueFrom(this.psicologoService.aprovaReprovaAjustePonto(body));
         if (!response.isSucess) {
         this.toastr.error(response.message, response.title);
         this.spinnerService.hide();
    return;
}

  this.jornada = response.data;
  this.calcularHoras();
  this.toastr.success("Jornada reprovada com sucesso!");
  this.spinnerService.hide();

  setTimeout(() => {
  this.location.back();
}, 5000);
}

public confirmarReprovacao() {
    this.showRepproveConfirm = false;
    this.onReprovar();
}


public confirmarAprovacao() {
    this.showApproveConfirm = false;
    this.onAprovar();
}

  public async onAprovar() {
    this.spinnerService.show();

    const body: AjustePontoRequest = {
      codigoJornada: this.jornadaId,
      status:        1
    };

    const response = await lastValueFrom(this.psicologoService.aprovaReprovaAjustePonto(body));
         if (!response.isSucess) {
         this.toastr.error(response.message, response.title);
         this.spinnerService.hide();
    return;
}

  this.jornada = response.data;
  this.calcularHoras();
  this.toastr.success("Jornada aprovada com sucesso!");
  this.spinnerService.hide();

  setTimeout(() => {
  this.location.back();
}, 5000);

  }


}
